import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-radio-button", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("radio-button", "simple-radio-button"),
            componentTag: "ux-radio-button",
            pageHeight: 180,
            pageWidth: 400,
        });
    });

    it("passes the regression test error state", async () => {
        await regressionTest({
            storyId: getTestStory("radio-button", "error"),
            componentTag: "ux-radio-button",
            pageHeight: 180,
            pageWidth: 400,
        });
    });

    it("passes the regression test box version", async () => {
        await regressionTest({
            storyId: getTestStory("radio-button", "with-green-border"),
            componentTag: "ux-radio-button",
            performActions: async (page) => {
                await page.click("ux-radio-button[value='radio-media-3']");
                await page.click(
                    "ux-radio-button[value='radio-media-2'] label"
                );
            },
            pageWidth: 600,
            pageHeight: 800,
        });
    });
});
